"use client";
export { RootErrorTracked as default } from "@janeway/gui-elements";

